import React from 'react';

interface Icon3DDomainProps {
  size?: string;
}

const Icon3DDomain: React.FC<Icon3DDomainProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'rotate-domain 3s linear infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg 
          viewBox="0 0 24 24" 
          fill="none" 
          className="w-full h-full"
          style={{ filter: 'drop-shadow(0 2px 8px rgba(99, 102, 241, 0.3))' }}
        >
          <defs>
            <linearGradient id="domainGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#6366f1" />
              <stop offset="50%" stopColor="#818cf8" />
              <stop offset="100%" stopColor="#4f46e5" />
            </linearGradient>
          </defs>
          <circle cx="12" cy="12" r="10" fill="url(#domainGradient)" opacity="0.2" stroke="url(#domainGradient)" strokeWidth="1.5" />
          <circle cx="12" cy="12" r="7" fill="none" stroke="url(#domainGradient)" strokeWidth="1" />
          <circle cx="12" cy="12" r="2" fill="url(#domainGradient)" />
          <line x1="12" y1="5" x2="12" y2="3" stroke="url(#domainGradient)" strokeWidth="1.5" />
        </svg>
        <style>{`
          @keyframes rotate-domain {
            0% { transform: rotateZ(0deg); }
            100% { transform: rotateZ(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DDomain;
